import React from 'react'
import { StylesProvider } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import GlobalStyles from 'theme/GlobalStyles'
import theme from 'theme/theme'
import Routes from './Routes'

function App() {
  return (
    <StylesProvider injectFirst>
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        <Routes>
          New Kuruma Front
        </Routes>
      </ThemeProvider>
    </StylesProvider>
  )
}

export default App
